import request from '../utils/request';

/**
 * 训练营进度接口
 */
export function campDayProgress(params) {
  return request.MainService({
    url: `/ddilearner/v2/camp/dayProgress`,
    method: 'get',
    params: params
  })
}

/**
 * 训练营列表接口（PC列表页新接口）
 */
export function campList(campMetasProjectId) {
  return request.MainService({
    url: `/ddilearner/v3/camp/listt/${campMetasProjectId}`,
    method: 'get'
  })
}

/**
 * 训练营第X天所有元素的列表接口（只包含状态，不包含进度）
 * @param courseId
 * @returns {AxiosPromise}
 */
export function getCampEleList(campMetasProjectId,learningPathMetaId) {
  return request.MainService({
    url: `/ddilearner/v3/camp/dayList/${campMetasProjectId}/${learningPathMetaId}`,
    method: 'get'
  })
}

/**
 * 训练营第X天里面课程详情接口
 * @param courseId
 * @returns {AxiosPromise}
 */
export function getCampCourseList(courseId) {
  return request.MainService({
    url: `sr/course/${courseId}`,
    method: 'get'
  })
}

/**
 * 训练营第X天里面所有元素详情接口(与get接口不同，需要先创建)
 * @param courseId
 * @returns {AxiosPromise}
 */
export function postCampCourseByCourseId(courseMetaId){
  return request.MainService({
    url: 'sr/' + courseMetaId + "/courses",
    method: 'post'
  })
}

  /**
   * 根据第一题选择的选项id获取PDF文件
   * @param postData: JSONObject 选择题选项
   */
export function getExercisePdfAPI(postData) {
  return request.MainService({
    url: 'ddilearner/v2/camp/applicationPractice/actualOperation/getExercisePdf',
    data: postData,
    method: 'post'
  })
}

/**
 * 实战作业上传附件
 */
export function campFileUploadApi(data,constituteId,questionId) {
  return request.MainService({
    method: 'POST',
    url: `ddilearner/v2/camp/applicationPractice/actualOperation/${constituteId}/${questionId}/fileUpload`,
    data:data.files,
  })
}

/**
 * 实战作业上传附件2
 */
export function campFileUploadApiNew(data,constituteId,questionId,toolsKey) {
  return request.MainService({
    method: 'POST',
    url: `ddilearner/v3/camp/applicationPractice/actualOperation/${constituteId}/${questionId}/${toolsKey}/fileUpload`,
    data:data.files,
  })
}


  /**
   * 获取上传文件列表
   * @param postData: JSONObject 查询文件条件对象
   */
  export function getUploadFileList(postData){
    return  request.MainService({
      method: 'POST',
      url: `ddilearner/v2/camp/applicationPractice/actualOperation/getCampFileList`,
      data:postData
    })
  }



// WEBPACK FOOTER //
// ./src/api/camp.js